<template>
  <div class="user-info-wrapper">
    <user-info-detail :value="user" @preview="toggleQrcode" />
    <user-info-list :links="links" />
    <!-- <van-overlay :show="qrcodeShown" @click="toggleQrcode">
      <div class="qrcode-wrapper" @click.stop>
        <div class="qrcode">
          <van-image :src="user.qrcode" />
        </div>
        <div class="tips-wrapper">
          <p>您的小时卡余额为{{ user.hours }}</p>
          <p class="tip">可在店内消费￥{{ user.hours * 100 }}</p>
        </div>
      </div>
    </van-overlay> -->
    <van-dialog
      v-model="show"
      title="会员注册"
      confirm-button-text="注册"
      @confirm="handleRegister"
    >
      <van-field
        v-model="tel"
        label="手机号"
        :colon="true"
        clearable
        type="tel"
        placeholder="请输入您的手机号码"
        :required="true"
      />
      <div class="qrcoder">
        <p>{{ register_notice }}</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Notify } from 'vant';
import { getUserDetail, createUserDetail } from '@/api/api-user';
import UserInfoDetail from './UserInfoDetail';
import UserInfoList from './UserInfoList';

export default {
  components: {
    UserInfoDetail,
    UserInfoList,
  },
  data() {
    return {
      tel: '',
      telReg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      show: false,
      qrcodeShown: false,
      register_notice: '',
      agent: null,
      colors: ['#f38181', '#fce38a', '#eaffd0', '#95e1d3'],
    };
  },
  computed: {
    ...mapGetters(['user']),
    links() {
      const linkList = [
        [
          // {
          //   icon: 'qr',
          //   color: this.colors[1],
          //   title: '会员二维码',
          //   notLink: true,
          //   action: this.toggleQrcode,
          // },
          // {
          //   icon: 'bill-o',
          //   color: this.colors[0],
          //   title: '会员充值',
          //   path: '/user_info/recharge',
          // },
          {
            icon: 'coupon-o',
            color: this.colors[1],
            title: '赠票领取',
            path: '/user_info/bonus_scan',
          },
        ],
        [
          {
            icon: 'records',
            color: this.colors[2],
            title: '充值记录',
            path: '/user_info/recharge_list',
          },
          {
            icon: 'records',
            color: this.colors[3],
            title: '余额变动',
            path: '/user_info/consume_list',
          },
        ],
        // [
        //   {
        //     icon: 'coupon-o',
        //     color: this.colors[2],
        //     title: '我的优惠券',
        //     path: '/user_info/my_coupon',
        //   },
        //   {
        //     icon: 'coupon-o',
        //     color: this.colors[3],
        //     title: '领取优惠券',
        //     path: '/user_info/get_coupon',
        //   },
        // ]
        /*  [
					  {
					    icon: 'records',
					    color: this.colors[0],
					    title: '返利记录',
					    path: '/user_info/hours_rebate_list',
					  },
					  {
					    icon: 'records',
					    color: this.colors[1],
					    title: '参赛记录',
					    path: '/user_info/participation_list',
					  },
					],
					[
					  {
					    icon: 'records',
					    color: this.colors[2],
					    title: '余额变更记录',
					    path: '/user_info/balance_list',
					  },
					  {
					    icon: 'records',
					    color: this.colors[3],
					    title: '积分变更记录',
					    path: '/user_info/integral_list',
					  },
					  {
					    icon: 'records',
					    color: this.colors[0],
					    title: '小时卡变更记录',
					    path: '/user_info/hours_list',
					  },
					], */
      ];
      const extraLinks = [
        {
          icon: 'balance-o',
          color: this.colors[2],
          title: '提现',
          path: '/user_info/withdraw',
        },
        {
          icon: 'share',
          color: this.colors[3],
          title: '分享链接',
          path: '/user_info/share',
        },
        {
          icon: 'after-sale',
          color: this.colors[0],
          title: '返利记录',
          path: '/user_info/rebate_list',
        },
      ];
      // const agentList = [
      //   {
      //     icon: 'after-sale',
      //     color: '#f38181',
      //     title: '代理商返利',
      //     path: '/user_info/agent',
      //   },
      // ];
      // return links;
      const { more } = this.user;
      let list = [];
      if (more === 1) {
        list = [...linkList, extraLinks];
      } else {
        list = [...linkList];
      }
      // if (this.agent === 1) {
      //   list = [...list, agentList];
      // }
      return list;
    },
  },
  created() {
    this.getUser();
    this.getUserDetail();
  },
  methods: {
    ...mapActions(['getUser']),
    // eslint-disable-next-line consistent-return
    async handleRegister() {
      if (this.tel.trim().length === 0 || !this.telReg.test(this.tel)) {
        Notify('请输入正确的手机号!');
        return false;
      }
      const { code } = await createUserDetail({ tel: this.tel });
      if (code === 200) {
        this.show = true;
      }
    },

    toggleQrcode() {
      this.qrcodeShown = !this.qrcodeShown;
    },
    async getUserDetail() {
      const {
        is_agent: agent,
        tel,
        register_notice: notice,
      } = await getUserDetail();
      this.agent = agent;
      this.register_notice = notice;
      // eslint-disable-next-line no-bitwise
      if (!~~tel) {
        this.show = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-wrapper {
  margin-bottom: 50px;

  .qrcode-wrapper {
    text-align: center;
    background: #fff;
    padding: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    overflow: hidden;

    .tips-wrapper {
      color: #999;
      font-size: 14px;
      margin: 24px 0 0;

      .tip {
        margin: 8px;
      }
    }
  }
}
.qrcoder {
  padding: 20px;
  font-size: 0.9rem;
}
/deep/ .van-dialog__content img {
  width: 100rpx;
  height: 100rpx;
}
</style>
